import { render } from "./ctcp_request.vue?vue&type=template&id=34458cf8&ts=true"
import script from "./ctcp_request.vue?vue&type=script&lang=ts"
export * from "./ctcp_request.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Users\\orson\\coding\\thelounge\\thelounge\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"client/components/MessageTypes/ctcp_request.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "34458cf8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('34458cf8', __exports__)) {
    api.reload('34458cf8', __exports__)
  }
  
  module.hot.accept("./ctcp_request.vue?vue&type=template&id=34458cf8&ts=true", () => {
    api.rerender('34458cf8', render)
  })

}


export default __exports__